module.exports = "/assets/data/f8af212c069427db3b2fca4226ec0901-G42.data.json";